import { createContext, useMemo } from 'react';

interface EducationSlideEditContextValue {
  isEditMode: boolean;
  /**
   * Whether the current page being edited is a custom page (vs. a template page).
   * Custom pages allow editing the full layout including TwoColumnLayout props and title.
   */
  isCustomPage: boolean;
}

const EducationSlideEditContext = createContext<EducationSlideEditContextValue>(
  {
    isEditMode: false,
    isCustomPage: false,
  }
);

export interface EducationSlideEditProviderProps {
  isEditMode: boolean;
  isCustomPage?: boolean;
  children: React.ReactNode;
}

export function EducationSlideEditProvider({
  isEditMode,
  isCustomPage = false,
  children,
}: EducationSlideEditProviderProps) {
  const value = useMemo(
    () => ({ isEditMode, isCustomPage }),
    [isEditMode, isCustomPage]
  );

  return (
    <EducationSlideEditContext.Provider value={value}>
      {children}
    </EducationSlideEditContext.Provider>
  );
}
